import "@fontsource/dm-sans";
import "@fontsource/inter";
import "@fontsource/poppins";
import "@fontsource/poppins/100.css";
import "@fontsource/poppins/200.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "./theme/theme.scss";
import "./components/common/css/RDT_common.scss";
import "./components/dashboard/Assets/UsersAssets/UsersAssets.scss";
import "./components/dashboard/Dashboard/Dashboard.scss";
import "./components/dashboard/Users/UsersList.scss";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
//todo need this as MFAList.scss is used at multiple places. Need to move it to a common place.
import "./components/dashboard/TwoFa/MFAList/MFAList.scss";

import "./components/common/css/RDT_common.scss";
import "./components/dashboard/Assets/UsersAssets/UsersAssets.scss";
import "./components/dashboard/Dashboard/Dashboard.scss";
import "./components/dashboard/Users/UsersList.scss";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { record } from "rrweb";
import { v4 as uuidv4 } from "uuid";
import axios from "./api/axios_interceptor";
import { get_jwt_token, loginRedirect } from "./api/helper_funtions";
import { sendEventStream } from "./api/session_recording";
import { getBrandingFavicon } from "./api/branding";
import HeaderSkeleton from "./components/common/Skeletons/HeaderSkeleton";
import HomeSkeleton from "./components/common/Skeletons/HomeSkeleton";
import SidebarSkeleton from "./components/common/Skeletons/SidebarSkeleton";
import FileManagerSkeleton from "./components/common/Skeletons/FileManagerSkeleton";
import DatabaseGUI from "./components/dashboard/Apps/DatabaseGUI/DatabaseGUI";
import { ResultsProvider } from "./components/dashboard/Apps/DatabaseGUI/ResultsProvider";

import ConsumeToken from "./components/user/Login/ConsumeToken";
import Check from "./components/user/Login/check";
import Login from "./components/user/Login/login";
import AuditDashboardRoutes from "./routes/AuditDashboardRoutes";
import DashboardRoutes from "./routes/DashboardRoutes";
import {
  getLiveStreamInfo,
  getResourceLiveStreamInfo,
  getResourceSessionInfo,
  getSessionInfo,
  getProxyInfo,
} from "./state/slices/customer";
import { logoutUser } from "./state/slices/user";
import { getAccessedResourcePolicy } from "./utils/accessedResourcePolicy";
import useWindowDimensions from "./utils/getHeightWidth";
import { registerAdmin } from "./api/customer";
import { setIsOnPremise, getDiscoveryFeatureAccess } from "./state/slices/customer";
import PromptForCredentialsPage from "./components/common/CredentialsPrompt/PromptForCredentialsPage";
import { getOrganisationDomain } from "./api/branding";
import BrandingGateOverlay from "./components/Branding/BrandingGateOverlay";
import { useAppTheme } from "./theme/useTheme";
import { setThemeMode } from "./state/slices/theme";
import { decodeResourceParams } from "./utils/urlEncoder";
import DataTable from "react-data-table-component";
import { LazyLoadImage } from "react-lazy-load-image-component";
import FirstPageIcon from "./images/first_page.svg";
import LastPageIcon from "./images/last_page.svg";
import NextPageIcon from "./images/arrow_right.svg";
import PreviousPageIcon from "./images/arrow_left.svg";

// Set global default pagination icons for all DataTable instances
DataTable.defaultProps = {
  ...DataTable.defaultProps,
  paginationIconFirstPage: <LazyLoadImage src={FirstPageIcon} alt="first page" />,
  paginationIconLastPage: <LazyLoadImage src={LastPageIcon} alt="last page" />,
  paginationIconNext: <LazyLoadImage src={NextPageIcon} alt="next" />,
  paginationIconPrevious: <LazyLoadImage src={PreviousPageIcon} alt="previous" />,
};

const Header = lazy(() => import("./components/layouts/Header/Header"));
const Sidebar = lazy(() => import("./components/dashboard/Sidebar/Sidebar"));
const AuditSidebar = lazy(() => import("./components/dashboard/Sidebar/AuditSidebar"));
const ForgotPassword = React.lazy(() =>
  import("./components/user/ForgotPassword/ForgotPassword"),
);
const Register = React.lazy(() => import("./components/user/Login/register"));
const FileManager = lazy(() =>
  import("./components/dashboard/FileManager/FileManager"),
);
const LiveReplayer = lazy(() =>
  import("./components/dashboard/LiveSession/LiveReplayer"),
);
const XtermLiveReplayer = lazy(() =>
  import("./components/dashboard/LiveSession/XtermLiveReplayer"),
);
const SessionPlayer = lazy(() =>
  import("./components/dashboard/SessionPlayer/SessionPlayer"),
);
const ResetPassword = React.lazy(() =>
  import("./components/user/ResetPassword/ResetPassword"),
);
const UpdatePassword = React.lazy(() =>
  import("./components/user/UpdatePassword/UpdatePassword"),
);
const ApplicationDefinition = lazy(() =>
  import(
    "./components/dashboard/ApplicationManagement/ApplicationDefinition/ApplicationDefinition"
  ),
);
const ApplicationGroup = lazy(() =>
  import(
    "./components/dashboard/ApplicationManagement/ApplicationGroup/ApplicationGroup"
  ),
);
const CreateApplicationGroup = lazy(() =>
  import(
    "./components/dashboard/ApplicationManagement/ApplicationGroup/CreateApplicationGroup"
  ),
);

const Users = lazy(() => import("./components/dashboard/EndpointManagement/Users"));

const Devices = lazy(() => import("./components/dashboard/EndpointManagement/Devices"));
const DeviceGroup = lazy(() =>
  import("./components/dashboard/EndpointManagement/DeviceGroup"),
);
const DeviceGroupDevices = lazy(() =>
  import("./components/dashboard/EndpointManagement/DeviceGroupDevices"),
);
const ShareLinkRedirect = lazy(() =>
  import("./components/common/ShareLinkRedirect/ShareLinkRedirect"),
);
const MonitorLinkRedirect = lazy(() =>
  import("./components/common/MonitorLinkRedirect/MonitorLinkRedirect"),
);

function App() {
  const { height, width } = useWindowDimensions();
  const { mode, effectiveMode } = useAppTheme();
  const navigate = useNavigate();
  const startSessionRecording = useRef(null);
  const startLiveRecording = useRef(null);
  const [favicon, setFavicon] = useState(null);
  const [recordToggle, setRecordToggle] = useState([true]);
  const { isAuthenticated } = useSelector((state) => state.user);
  const customer_id = useSelector((state) => state.user?.user?.customer);
  const session_key = useSelector((state) => state.user?.session_key || "");
  const capabilities = useSelector(
    (state) => state.user?.user?.role?.capabilities || {},
  );
  const isCapable = "is_admin_user" in capabilities ? capabilities : false;
  const isCapableEnduser = "is_end_user" in capabilities ? capabilities : false;
  const { recordSession } = useSelector((state) => state.customer);
  const { liveStream } = useSelector((state) => state.customer);
  const { isOnPremise } = useSelector((state) => state.customer);
  const [resourceRecordSession, setResourceRecordSession] = useState("");
  const [resourceLiveStream, setResourceLiveStream] = useState("");
  const location = useLocation();
  const isRecording = useRef(false);
  const [brandingMissing, setBrandingMissing] = useState(false);
  const [brandingChecked, setBrandingChecked] = useState(false);
  const [rootDomainSuffix, setRootDomainSuffix] = useState(".xecurify.com");
  const isAdmin = !!(capabilities && capabilities.is_admin_user);
  const canEditBranding = !!(capabilities && capabilities.branding && capabilities.branding.edit_branding_setting);
  const serverURL = useSelector((state) => state.customer.serverUrl);
  const user_id = useSelector((state) => state.user?.user?.id || "");
  const ws_protocol = window.location.protocol === "https:" ? "wss" : "ws";
  const ws_endpoint = `${serverURL.replace(
    /http:|https:/gi,
    ws_protocol + ":"
  )}/ws/livesession/${customer_id}/?session_key=${session_key}&user_id=${user_id}&tab_id=${window.name}`;
  let recorder = [];
  const dispatch = useDispatch();

  const policyId = window.location.search.includes("data") ? decodeResourceParams(new URLSearchParams(window.location.search).get("data"))?.policy_id
    : new URLSearchParams(window.location.search).get("policy_id");

  const systemuserId = window.location.search.includes("data") ? decodeResourceParams(new URLSearchParams(window.location.search).get("data"))?.systemuser_id
    : new URLSearchParams(window.location.search).get("systemuser_id");

  const { oauthUrl } = useSelector((state) => state.customer);
  const user = useSelector((state) => state.user?.user);
  const userPreferences = user?.user_preferences;
  if (user_id != "") {
    if (window.name === "") {
      const name = uuidv4();
      window.name = name;
    }
  }


  const themeSyncedRef = useRef(false);
  useEffect(() => {
    if (isAuthenticated && userPreferences?.theme && !themeSyncedRef.current) {
      const savedTheme = userPreferences.theme;
      // Backend can have "light", "dark", or "system"
      if (savedTheme === "light" || savedTheme === "dark" || savedTheme === "system") {

        dispatch(setThemeMode(savedTheme));
        themeSyncedRef.current = true;
      }
    }

    if (!isAuthenticated) {
      themeSyncedRef.current = false;
    }
  }, [isAuthenticated, userPreferences?.theme, dispatch]);

  useEffect(() => {
    // Branding gate: only admins with capability can set branding
    const checkBranding = async () => {
      try {
        const resp = await getOrganisationDomain();
        const brandingVal = resp?.data?.branding;
        const exists = !!brandingVal && String(brandingVal).trim().toLowerCase() !== "none";
        setBrandingMissing(!exists);
        if (!exists) {
          const suffix = resp?.data?.root_domain || ".xecurify.com";
          setRootDomainSuffix(suffix);
        }
      } catch (e) {
        // On API error, do not prompt branding
        setBrandingMissing(false);
      } finally {
        setBrandingChecked(true);
      }
    };
    if (isAuthenticated && canEditBranding) {
      setBrandingChecked(false);
      checkBranding();
    } else {
      // Skip prompting and mark as checked
      setBrandingMissing(false);
      setBrandingChecked(isAuthenticated ? true : false);
    }
  }, [isAuthenticated, canEditBranding]);

  useEffect(() => {
  }, [isAuthenticated, brandingChecked, brandingMissing, capabilities, location.pathname, navigate]);

  useEffect(() => {
    const fetchPolicy = async () => {
      const pathSegment = window.location.pathname.split("/")[2];
      const urlParams = new URLSearchParams(window.location.search);
      let resourceId = decodeResourceParams(urlParams.get("data"))?.resource_id;

      if (pathSegment === "file_manager" && policyId && systemuserId) {
        let {data, error} = await getAccessedResourcePolicy(
            "assets",
            resourceId,
            systemuserId,
        );
        if (data) {
          setResourceRecordSession(data.record_session ? "true" : "false");
          setResourceLiveStream(data.live_stream ? "true" : "false");
        }
        if (error) {
        }
      } else if (pathSegment === "database-gui" && policyId && systemuserId) {
        let { data, error } = await getAccessedResourcePolicy(
          "apps",
          resourceId,
          systemuserId,
        );
        if (data) {
          setResourceRecordSession(data.record_session ? "true" : "false");
          setResourceLiveStream(data.live_stream ? "true" : "false");
        }
        if (error) {
          // Error handled silently
        }
      }
    };
    fetchPolicy();
  }, [policyId, systemuserId, location.pathname]);

  function getSessionTypeAndResourceIDs() {
    // Default session info
    let sessionType = "Dashboard";
    let resourceID = "-";
    let resourceAccessID = "-";
    // If URL path includes "file_manager", override these:
    if (location.pathname.includes("file_manager")) {
      sessionType = "Asset";
      const params = new URLSearchParams(location.search);
      const resource_access_report_id = sessionStorage.getItem(decodeResourceParams(params.get("data"))?.token_key);

      resourceID = decodeResourceParams(params.get("data"))?.resource_id || "-";
      resourceAccessID = resource_access_report_id || "-";
    }
    // If URL path includes "database-gui", override these:
    else if (location.pathname.includes("database-gui")) {
      sessionType = "App";
      const params = new URLSearchParams(location.search);
      const decodedData = decodeResourceParams(params.get("data"));
      const resource_access_report_id = sessionStorage.getItem(
        decodedData?.token_key
      );

      resourceID = decodedData?.resource_id || "-";
      resourceAccessID = resource_access_report_id || "-";
    }

    return { sessionType, resourceID, resourceAccessID };
  }

  const waitForResourceAccessId = () => {
    if (!location.pathname.includes("file_manager") && !location.pathname.includes("database-gui")) {
      return Promise.resolve(true);
    }
    const params = new URLSearchParams(location.search);
    const tokenKey = decodeResourceParams(params.get("data"))?.token_key;
    if (!tokenKey) {
      return Promise.resolve(true);
    }
    return new Promise((resolve) => {
      const checkAndResolve = () => {
        const storedId = sessionStorage.getItem(tokenKey);
        if (storedId && storedId !== "-") {
          resolve(true);
        } else {
          setTimeout(checkAndResolve, 300);
        }
      };
      checkAndResolve();
    });
  };

  function SessionRecordStop() {
    if (startSessionRecording.current) {
      startSessionRecording.current();
      startSessionRecording.current = null;
      return true;
    }
  }

  function LiveRecordStop() {
    if (startLiveRecording.current) {
      startLiveRecording.current();
      startLiveRecording.current = null;
      return true;
    }
  }

  if (!window.location.pathname.split("/").includes("livestream") &&
    !window.location.pathname.split("/").includes("session-player")) {
    sessionStorage.removeItem("livestreaming");
  }

  useEffect(() => {
    const pathSegment = window.location.pathname.split("/")[2];
    if (
      isAuthenticated == true &&
      liveStream == "true" &&
      recordSession != "" &&
      pathSegment != "file_manager" &&
      pathSegment != "database-gui" &&
      pathSegment !== "prompt-for-credentials" &&
      user_id != "" &&
      session_key != ""
    ) {
      const recording_ws_connection = new WebSocket(ws_endpoint);
      recording_ws_connection.onopen = function (e) {
        recording_ws_connection.send(
          JSON.stringify({
            type: "active_tabs_list",
            message: "get_tab_id",
            session_key: session_key,
          }),
        );
      };

      recording_ws_connection.onmessage = function (e) {
        const data = JSON.parse(e.data);
        if (
          data.type === "active_tabs_list" &&
          data.message === "get_tab_id" &&
          window.location.pathname.split("/")[2] != "livestream" &&
          window.location.pathname.split("/")[2] != "xterm" &&
          window.location.pathname.split("/")[2] != "session-player"
        ) {
          const data_message = {
            tab_id: window.name,
            user_id: user_id,
            session_type: "Dashboard",
            access_type: "browser_session",
            session_type_id: "-",
          };
          recording_ws_connection.send(
            JSON.stringify({
              type: "active_users",
              message: data_message,
              session_key: session_key,
            }),
          );
        }
        if (
          data.type === "start_recording" &&
          window.name == data.message.tab_id &&
          isAuthenticated
        ) {
          if (SessionRecordStop()) {
            sessionStorage.setItem("live_recording", "on");
            startLiveRecording.current = record({
              emit: (event) => {
                const data_message = { event: event, tab: window.name };
                recorder.push(event);
                if (recorder.length > 10) {
                  const recording_event_response = sendEventStream({
                    event_stream: recorder,
                    video_id: window.name,
                    session_type: "Dashboard",
                    resource_id: "-",
                    resource_access_id: "-",
                  });
                  recorder = [];
                }
                recording_ws_connection.send(
                  JSON.stringify({
                    type: "recorded_events",
                    message: data_message,
                    session_key: session_key,
                  }),
                );
              },
              recordCanvas: true,
              sampling: {
                canvas: 15,
              },
              // optional image format settings
              dataURLOptions: {
                type: "image/webp",
                quality: 0.6,
              },
            });
          } else {
            if (sessionStorage.getItem("live_recording") != "on" || LiveRecordStop()) {
              sessionStorage.setItem("live_recording", "on");
              startLiveRecording.current = record({
                emit: (event) => {
                  const data_message = { event: event, tab: window.name };
                  recording_ws_connection.send(
                    JSON.stringify({
                      type: "recorded_events",
                      message: data_message,
                      session_key: session_key,
                    }),
                  );
                },
                recordCanvas: true,
                sampling: {
                  canvas: 15,
                },
                // optional image format settings
                dataURLOptions: {
                  type: "image/webp",
                  quality: 0.6,
                },
              });
            } else {
              const data_message = { onlive: data.message.window_name };
              recording_ws_connection.send(
                JSON.stringify({
                  type: "recorded_events",
                  message: data_message,
                  session_key: session_key,
                }),
              );
            }
          }
        }
        if (data.type === "stop_recording") {
          sessionStorage.removeItem("live_recording");
          if (LiveRecordStop()) {
            if (
              recordSession === "true" &&
              window.location.pathname.split("/")[2] !== "livestream" &&
              window.location.pathname.split("/")[2] !== "session-player" &&
              sessionStorage.getItem("live_recording") !== "on" &&
              SessionRecordStop() &&
              isAuthenticated
            ) {
              startSessionRecording.current = record({
                emit(e) {
                  recorder.push(e);
                  if (recorder.length > 10) {
                    const recording_event_response = sendEventStream({
                      event_stream: recorder,
                      video_id: window.name,
                      session_type: "Dashboard",
                      resource_id: "-",
                      resource_access_id: "-",
                    });
                    recorder = [];
                  }
                },
                recordCanvas: true,
                sampling: {
                  canvas: 15,
                },
                // optional image format settings
                dataURLOptions: {
                  type: "image/webp",
                  quality: 0.6,
                },
              });
            }
          }
        }
        if (data.type === "kill_session" && data.message === window.name) {
          sessionStorage.removeItem("live_recording");
          recording_ws_connection.send(
            JSON.stringify({
              type: "remove_row",
              message: window.name,
              session_key: session_key,
            }),
          );
          const token = get_jwt_token();
          loginRedirect(token);
          dispatch(logoutUser());
        }
      };
    }
  }, [isAuthenticated, recordSession, user_id, liveStream, session_key]);

  //adding for SFTP and DatabaseGUI
  useEffect(() => {
    const pathSegment = window.location.pathname.split("/")[2];
    if (
      isAuthenticated == true &&
      resourceLiveStream == "true" &&
      (pathSegment == "file_manager" || pathSegment == "database-gui") &&
      resourceRecordSession != "" &&
      user_id != "" &&
      session_key != ""
    ) {
      const recording_ws_connection = new WebSocket(ws_endpoint);
      recording_ws_connection.onopen = function (e) {
        recording_ws_connection.send(
          JSON.stringify({
            type: "active_tabs_list",
            message: "get_tab_id",
            session_key: session_key,
          }),
        );
      };

      recording_ws_connection.onmessage = function (e) {
        const data = JSON.parse(e.data);
        const params = new URLSearchParams(window.location.search);
        let session_type_id = "-";
        const resourceID = decodeResourceParams(params.get("data"))?.resource_id
        if (resourceID) {
          session_type_id = resourceID;
        }
        const currentPathSegment = window.location.pathname.split("/")[2];
        if (
          data.type === "active_tabs_list" &&
          data.message === "get_tab_id" &&
          currentPathSegment != "livestream" &&
          currentPathSegment != "xterm"
        ) {
          // Determine session type based on path: "App" for database-gui, "Asset" for file_manager
          const session_type = currentPathSegment === "database-gui" ? "App" : "Asset";
          const data_message = {
            tab_id: window.name,
            user_id: user_id,
            session_type: session_type,
            access_type:
              currentPathSegment === "database-gui"
                ? "react_database_gui"
                : "browser_session",
            session_type_id: session_type_id,
          };
          recording_ws_connection.send(
            JSON.stringify({
              type: "active_users",
              message: data_message,
              session_key: session_key,
            }),
          );
        }
        if (
          data.type === "start_recording" &&
          window.name == data.message.tab_id &&
          isAuthenticated
        ) {
          const startSftpRecording = () => {
            if (SessionRecordStop()) {
              sessionStorage.setItem("live_recording", "on");
              startLiveRecording.current = record({
                emit: (event) => {
                  const data_message = { event: event, tab: window.name };
                  recorder.push(event);
                  if (recorder.length > 10) {
                    const { sessionType, resourceID, resourceAccessID } =
                      getSessionTypeAndResourceIDs();
                    const recording_event_response = sendEventStream({
                      event_stream: recorder,
                      video_id: window.name,
                      session_type: sessionType,
                      resource_id: resourceID,
                      resource_access_id: resourceAccessID,
                    });
                    recorder = [];
                  }
                  recording_ws_connection.send(
                    JSON.stringify({
                      type: "recorded_events",
                      message: data_message,
                      session_key: session_key,
                    }),
                  );
                },
                recordCanvas: true,
                sampling: {
                  canvas: 15,
                },
                // optional image format settings
                dataURLOptions: {
                  type: "image/webp",
                  quality: 0.6,
                },
              });
            } else {
              if (sessionStorage.getItem("live_recording") != "on" || LiveRecordStop()) {
                sessionStorage.setItem("live_recording", "on");
                startLiveRecording.current = record({
                  emit: (event) => {
                    const data_message = { event: event, tab: window.name };
                    recording_ws_connection.send(
                      JSON.stringify({
                        type: "recorded_events",
                        message: data_message,
                        session_key: session_key,
                      }),
                    );
                  },
                  recordCanvas: true,
                  sampling: {
                    canvas: 15,
                  },
                  // optional image format settings
                  dataURLOptions: {
                    type: "image/webp",
                    quality: 0.6,
                  },
                });
              } else {
                const data_message = { onlive: data.message.window_name };
                recording_ws_connection.send(
                  JSON.stringify({
                    type: "recorded_events",
                    message: data_message,
                    session_key: session_key,
                  }),
                );
              }
            }
          };
          waitForResourceAccessId().then(startSftpRecording);
        }
        if (data.type === "stop_recording") {
          sessionStorage.removeItem("live_recording");
          if (LiveRecordStop()) {
            if (
              recordSession === "true" &&
              window.location.pathname.split("/")[2] !== "livestream" &&
              window.location.pathname.split("/")[2] !== "session-player" &&
              sessionStorage.getItem("live_recording") !== "on" &&
              SessionRecordStop() &&
              isAuthenticated
            ) {
              startSessionRecording.current = record({
                emit(e) {
                  recorder.push(e);
                  if (recorder.length > 10) {
                    const { sessionType, resourceID, resourceAccessID } =
                      getSessionTypeAndResourceIDs();
                    const recording_event_response = sendEventStream({
                      event_stream: recorder,
                      video_id: window.name,
                      session_type: sessionType,
                      resource_id: resourceID,
                      resource_access_id: resourceAccessID,
                    });
                    recorder = [];
                  }
                },
                recordCanvas: true,
                sampling: {
                  canvas: 15,
                },
                // optional image format settings
                dataURLOptions: {
                  type: "image/webp",
                  quality: 0.6,
                },
              });
            }
          }
        }
        if (data.type === "kill_session" && data.message === window.name) {
          sessionStorage.removeItem("live_recording");
          recording_ws_connection.send(
            JSON.stringify({
              type: "remove_row",
              message: window.name,
              session_key: session_key,
            }),
          );
          const token = get_jwt_token();
          loginRedirect(token);
          dispatch(logoutUser());
        }
      };
    }
  }, [
    isAuthenticated,
    resourceRecordSession,
    user_id,
    resourceLiveStream,
    session_key,
  ]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchFavicon();
    }
    const fetchOnPremiseValue = async () => {
      const { data, error } = await registerAdmin();
      if (data && data?.is_on_premise !== undefined) {
        dispatch(setIsOnPremise(data?.is_on_premise));
      } else {
        dispatch(setIsOnPremise(false));
      }
    };
    fetchOnPremiseValue();
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getSessionInfo());
      dispatch(getLiveStreamInfo());
      dispatch(getResourceLiveStreamInfo());
      dispatch(getResourceSessionInfo());
      dispatch(getProxyInfo());
      dispatch(getDiscoveryFeatureAccess());
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (
      recordSession === "true" &&
      window.location.pathname.split("/")[2] != "file_manager" &&
      window.location.pathname.split("/")[2] != "database-gui" &&
      window.location.pathname.split("/")[2] !== "prompt-for-credentials" &&
      window.location.pathname.split("/")[2] !== "livestream" &&
      window.location.pathname.split("/")[2] !== "session-player" &&
      sessionStorage.getItem("live_recording") !== "on" &&
      isAuthenticated
    ) {
      startSessionRecording.current = record({
        emit(e) {
          recorder.push(e);
          if (recorder.length > 10) {
            const recording_event_response = sendEventStream({
              event_stream: recorder,
              video_id: window.name,
              session_type: "Dashboard",
              resource_id: "-",
              resource_access_id: "-",
            });
            recorder = [];
          }
        },
        recordCanvas: true,
        sampling: {
          canvas: 15,
        },
        // optional image format settings
        dataURLOptions: {
          type: "image/webp",
          quality: 0.6,
        },
      });
    }
  }, [recordSession, recordToggle]);

  //added for SFTP and DatabaseGUI
  useEffect(() => {
    const pathSegment = window.location.pathname.split("/")[2];
    if (
      resourceRecordSession === "true" &&
      (pathSegment == "file_manager" || pathSegment == "database-gui") &&
      pathSegment !== "livestream" &&
      sessionStorage.getItem("live_recording") !== "on" &&
      isAuthenticated
    ) {
      const startSftpSessionRecording = () => {
        startSessionRecording.current = record({
          emit(e) {
            recorder.push(e);
            if (recorder.length > 10) {
              const { sessionType, resourceID, resourceAccessID } =
                getSessionTypeAndResourceIDs();
              const recording_event_response = sendEventStream({
                event_stream: recorder,
                video_id: window.name,
                session_type: sessionType,
                resource_id: resourceID,
                resource_access_id: resourceAccessID,
              });
              recorder = [];
            }
          },
          recordCanvas: true,
          sampling: {
            canvas: 15,
          },
          // optional image format settings
          dataURLOptions: {
            type: "image/webp",
            quality: 0.6,
          },
        });
      };

      waitForResourceAccessId().then(startSftpSessionRecording);
    }
  }, [resourceRecordSession, recordToggle]);

  useEffect(() => {
    if (
      recordSession != "" &&
      window.location.pathname.split("/")[2] != "file_manager" &&
      window.location.pathname.split("/")[2] != "database-gui" &&
      window.location.pathname.split("/")[2] !== "prompt-for-credentials" &&
      liveStream == "true" &&
      session_key != "" &&
      isAuthenticated
    ) {
      if (performance.navigation.type === 1) {
        const recording_ws_connection = new WebSocket(ws_endpoint);

        if (sessionStorage.getItem("live_recording") == "on") {
          recording_ws_connection.onopen = function (e) {
            sessionStorage.setItem("live_recording", "on");
            startLiveRecording.current = record({
              emit: (event) => {
                const data_message = { event: event, tab: window.name };
                if (recordSession === "true" &&
                  window.location.pathname.split("/")[2] !== "livestream" &&
                  window.location.pathname.split("/")[2] !== "session-player") {
                  recorder.push(event);
                  if (recorder.length > 10) {
                    const recording_event_response = sendEventStream({
                      event_stream: recorder,
                      video_id: window.name,
                      session_type: "Dashboard",
                      resource_id: "-",
                      resource_access_id: "-",
                    });
                    recorder = [];
                  }
                }

                recording_ws_connection.send(
                  JSON.stringify({
                    type: "recorded_events",
                    message: data_message,
                    session_key: session_key,
                  }),
                );
              },
              recordCanvas: true,
              sampling: {
                canvas: 15,
              },
              // optional image format settings
              dataURLOptions: {
                type: "image/webp",
                quality: 0.6,
              },
            });
          };
        }
      }
    }
  }, [recordSession, session_key]);

  //added for SFTP and DatabaseGUI
  useEffect(() => {
    const pathSegment = window.location.pathname.split("/")[2];
    if (
      resourceRecordSession != "" &&
      (pathSegment == "file_manager" || pathSegment == "database-gui") &&
      liveStream == "true" &&
      session_key != "" &&
      isAuthenticated
    ) {
      if (performance.navigation.type === 1) {
        const recording_ws_connection = new WebSocket(ws_endpoint);

        if (sessionStorage.getItem("live_recording") == "on") {
          const startOnRefreshRecording = () => {
            recording_ws_connection.onopen = function (e) {
              sessionStorage.setItem("live_recording", "on");
              startLiveRecording.current = record({
                emit: (event) => {
                  const data_message = { event: event, tab: window.name };
                  if (recordSession === "true" &&
                    window.location.pathname.split("/")[2] !== "livestream" &&
                    window.location.pathname.split("/")[2] !== "session-player") {
                    recorder.push(event);
                    if (recorder.length > 10) {
                      const { sessionType, resourceID, resourceAccessID } =
                        getSessionTypeAndResourceIDs();
                      const recording_event_response = sendEventStream({
                        event_stream: recorder,
                        video_id: window.name,
                        session_type: sessionType,
                        resource_id: resourceID,
                        resource_access_id: resourceAccessID,
                      });
                      recorder = [];
                    }
                  }

                  recording_ws_connection.send(
                    JSON.stringify({
                      type: "recorded_events",
                      message: data_message,
                      session_key: session_key,
                    }),
                  );
                },
                recordCanvas: true,
                sampling: {
                  canvas: 15,
                },
                // optional image format settings
                dataURLOptions: {
                  type: "image/webp",
                  quality: 0.6,
                },
              });
            };
          };

          waitForResourceAccessId().then(startOnRefreshRecording);
        }
      }
    }
  }, [resourceRecordSession, session_key]);

  const fetchFavicon = async () => {
    const response = await getBrandingFavicon();
    if (response.data) {
      setFavicon(response.data);
      document.getElementById("favicon").href = response.data;
    }
  }

  useEffect(() => {
    const recording_ws_connection = new WebSocket(ws_endpoint);
    recording_ws_connection.onopen = function (e) {
      sessionStorage.removeItem("live_recording");
      if (isCapable && isCapable.report.live_session) {
        window.addEventListener("beforeunload", () => {
          recording_ws_connection.send(
            JSON.stringify({
              type: "stop_recording",
              message: "",
              session_key: session_key,
            }),
          );
          recording_ws_connection.send(
            JSON.stringify({
              type: "remove_row",
              message: window.name,
              session_key: session_key,
            }),
          );
        });
      } else {
        window.addEventListener("beforeunload", () => {
          recording_ws_connection.send(
            JSON.stringify({
              type: "remove_row",
              message: window.name,
              session_key: session_key,
            }),
          );
        });
      }
    };
  }, [isCapable, session_key]);
  window.addEventListener("storage", function (event) {
    if (event.key === "jwt") {
      window.location.reload(false);
    }
  });
  useEffect(() => {
    const path = location.pathname;

    if (path.startsWith("/dashboard") || path.startsWith("/audit-dashboard") || path.startsWith("/share") || path.startsWith("/livestreaming")) {
      sessionStorage.setItem("redirectAfterLogin", path);
    }
  }, [location.pathname]);

  return (
    <>
      {isAuthenticated && brandingChecked && canEditBranding && brandingMissing && (
        <BrandingGateOverlay
          rootDomainSuffix={rootDomainSuffix}
          onSuccess={() => {
            setBrandingMissing(false);
          }}
        />
      )}
      {isAuthenticated &&
        !sessionStorage.getItem("livestreaming") &&
        location.pathname !== "/file_manager/" &&
        location.pathname !== "/prompt-for-credentials" &&
        !location.pathname.includes('database-gui') &&
        location.pathname !== "/prompt-for-credentials" &&
        !location.pathname.startsWith("/pam/session-player") &&
        !location.pathname.startsWith("/session-player") && (
          <Suspense>
            <Header />
          </Suspense>
        )}
      <ToastContainer
        className="toast-container-custom"
        position="top-right"
        autoClose={3000}
        limit={1}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={effectiveMode}
      />

      <Routes>
        {isAuthenticated &&
          ((isCapableEnduser && isCapableEnduser.view_allocated_assets) ||
            (isCapable && isCapable.assets.view_allocated_assets)) && (
            <Route
              path="/file_manager"
              element={
                <Suspense fallback={<FileManagerSkeleton />}>
                  <FileManager />
                </Suspense>
              }
            />
          )}
        {isAuthenticated &&
          ((isCapableEnduser && isCapableEnduser.view_allocated_apps) ||
            (isCapable && isCapable.apps.view_allocated_apps)) && (
            <Route
              path="/database-gui"
              element={
                <Suspense >
                  <ResultsProvider><DatabaseGUI /></ResultsProvider>
                </Suspense>
              }
            />
          )}
        {isAuthenticated !== true && (
          <Route path="/token/:access_token" element={<ConsumeToken />} />
        )}
        {isAuthenticated && (
          <Route
            path="/livestream/:tab_id/:session_type/:username"
            element={
              <Suspense>
                <LiveReplayer />
              </Suspense>
            }
          />
        )}
        {isAuthenticated && (
          <Route
            path="/xterm/livestream/:tab_id/:username"
            element={
              <Suspense>
                <XtermLiveReplayer />
              </Suspense>
            }
          />
        )}
        {isAuthenticated && (
          <Route
            path="/share/:shareId"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <ShareLinkRedirect />
              </Suspense>
            }
          />
        )}
        {isAuthenticated && (
          <Route
            path="/livestreaming/:shareId"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <MonitorLinkRedirect />
              </Suspense>
            }
          />
        )}
        {isAuthenticated && (
          <Route
            path="/session-player/:video_id?"
            element={
              <Suspense>
                <SessionPlayer />
              </Suspense>
            }
          />
        )}

        {isAuthenticated !== true && (
          <Route
            path="/forgot-password"
            element={
              <Suspense>
                <ForgotPassword />
              </Suspense>
            }
          />
        )}
        {isAuthenticated !== true && (
          <Route
            path="/reset-password/:reset_token"
            element={
              <Suspense>
                <ResetPassword />
              </Suspense>
            }
          />
        )}
        {isAuthenticated !== true && (
          <Route
            path="/update-expired-password/:update_token"
            element={
              <Suspense>
                <UpdatePassword />
              </Suspense>
            }
          />
        )}

        {isAuthenticated === false && (
          <Route path="*" element={<Check />}>
            <Route path="login" element={<Login />} />
            <Route
              path="register"
              element={
                <Suspense>
                  <Register />
                </Suspense>
              }
            />
          </Route>
        )}

        {isAuthenticated && <Route path="*" element={<Navigate to="/dashboard" />} />}
        {isAuthenticated && (
          <Route
            path="dashboard/*"
            element={
              <Container
                fluid
                className={
                  width >= 768
                    ? "position-fixed px-0 w-100 h-100 "
                    : "position-absolute h-100 w-100"
                }
                style={{ zIndex: 1 }}
              >
                <Row className="w-100 h-100 mx-0 ">
                  <Col lg={2} md={3} className="position-relative sidebar-div px-0 h-100 pt-81px">
                    <div
                      className={
                        width >= 768
                          ? "h-100 overflow-auto sidebar-div sidebar-border-end"
                          : "h-100 overflow-auto sidebar-div"
                      }
                    >
                      <Suspense fallback={<SidebarSkeleton />}>
                        <Sidebar />
                      </Suspense>
                    </div>
                  </Col>
                  <Col
                    lg={10}
                    md={9}
                    className="h-100 px-0 bg-home pt-81px overflow-auto"
                  >
                    <DashboardRoutes />
                  </Col>
                </Row>
              </Container>
            }
          ></Route>
        )}
        {isAuthenticated &&
          isCapable &&
          isCapable.miscellaneous.setting.audit_dashboard && (
            <Route
              path="audit-dashboard/*"
              element={
                <Container
                  fluid
                  className={
                    width >= 768
                      ? "position-fixed px-0 w-100 h-100 "
                      : "position-absolute h-100 w-100"
                  }
                  style={{ zIndex: 1 }}
                >
                  <Row className="w-100 h-100 mx-0 ">
                    <Col lg={2} md={3} className="position-relative sidebar-div px-0 h-100 pt-81px">
                      <div
                        className={
                          width >= 768
                            ? "h-100 overflow-auto sidebar-div sidebar-border-end"
                            : "h-100 overflow-auto sidebar-div"
                        }
                      >
                        <Suspense fallback={<SidebarSkeleton />}>
                          <AuditSidebar />
                        </Suspense>
                      </div>
                    </Col>

                    <Col
                      lg={10}
                      md={9}
                      className="h-100 px-0 bg-home pt-81px overflow-auto"
                    >
                      <Suspense fallback={<HomeSkeleton />}>
                        <AuditDashboardRoutes />
                      </Suspense>
                    </Col>
                  </Row>
                </Container>
              }
            ></Route>
          )}
        {isAuthenticated && (
          <Route
            path="/prompt-for-credentials"
            element={<PromptForCredentialsPage />}
          />
        )}
      </Routes>
    </>
  );
}
export default App;
